const METERS_PER_MILE = 1609.344;
const DEFAULT_PRECEPTOR_RADIUS_MILES = 0.1;

const parseRadius = (): number => {
  const raw = process.env.NEXT_PUBLIC_PRECEPTOR_RADIUS_MILES;
  if (!raw) {
    return DEFAULT_PRECEPTOR_RADIUS_MILES;
  }

  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return DEFAULT_PRECEPTOR_RADIUS_MILES;
  }

  return parsed;
};

export const PRECEPTOR_RADIUS_MILES = parseRadius();
export const PRECEPTOR_RADIUS_METERS = PRECEPTOR_RADIUS_MILES * METERS_PER_MILE;
